import { render, staticRenderFns } from "./PortalEvent.vue?vue&type=template&id=6516f209&lang=pug"
import script from "./PortalEvent.vue?vue&type=script&lang=js"
export * from "./PortalEvent.vue?vue&type=script&lang=js"
import style0 from "./PortalEvent.vue?vue&type=style&index=0&id=6516f209&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports